//自定义标签
export function customRectangle(ctx, node) {
  var wr = node.borderRadius
  var hr = node.borderRadius

  if (node.borderRadius < 1) {
    wr = node.rect.width * node.borderRadius
    hr = node.rect.height * node.borderRadius
  }

  var r = wr < hr ? wr : hr

  if (node.rect.width < 2 * r) {
    r = node.rect.width / 2
  }

  if (node.rect.height < 2 * r) {
    r = node.rect.height / 2
  }

  ctx.beginPath()
  ctx.moveTo(node.rect.x + r, node.rect.y)
  if (node.data) {
    let orginFillStyle = ctx.fillStyle
    var customdata = node.data
    if (customdata.preText) {
      let preTextData = customdata.preText
      if (preTextData.fontSize) {
        ctx.font =
          (node.fontStyle || 'normal') +
          ' normal ' +
          (node.fontWeight || 'normal') +
          ' ' +
          preTextData.fontSize +
          'px/' +
          node.lineHeight +
          ' ' +
          node.fontFamily
      }
      // if (preTextData.fontColor) {
      //   ctx.fillStyle = preTextData.fontColor
      // }
      //前缀颜色取用父节点
      ctx.fillStyle = node.fillStyle
      if (preTextData.text) {
        let metrics = ctx.measureText(preTextData.text)
        let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
        ctx.fillText(
          preTextData.text,
          node.rect.x - Math.floor(metrics.width) - 5,
          node.rect.y + node.rect.height / 2 + actualHeight / 2 - 1.5
        )
      }
    }
    if (customdata.endText) {
      let endTextData = customdata.endText
      if (endTextData.fontSize) {
        ctx.font =
          (node.fontStyle || 'normal') +
          ' normal ' +
          (node.fontWeight || 'normal') +
          ' ' +
          endTextData.fontSize +
          'px/' +
          node.lineHeight +
          ' ' +
          node.fontFamily
      }
      // if (endTextData.fontColor) {
      //   ctx.fillStyle = endTextData.fontColor
      // }
      //后缀颜色取用父节点
      ctx.fillStyle = node.fillStyle
      if (endTextData.text) {
        let metrics = ctx.measureText(endTextData.text)
        let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
        ctx.fillText(
          endTextData.text,
          node.rect.x + node.rect.width + 5,
          node.rect.y + node.rect.height / 2 + actualHeight / 2 - 0.5
        )
      }
    }
    ctx.fillStyle = orginFillStyle
  }

  ctx.arcTo(
    node.rect.x + node.rect.width,
    node.rect.y,
    node.rect.x + node.rect.width,
    node.rect.y + node.rect.height,
    r
  )
  ctx.arcTo(
    node.rect.x + node.rect.width,
    node.rect.y + node.rect.height,
    node.rect.x,
    node.rect.y + node.rect.height,
    r
  )
  ctx.arcTo(node.rect.x, node.rect.y + node.rect.height, node.rect.x, node.rect.y, r)
  ctx.arcTo(node.rect.x, node.rect.y, node.rect.x + node.rect.width, node.rect.y, r)
  ctx.closePath()
  ;(node.fillStyle || node.bkType) && ctx.fill()
  ctx.stroke()
}
